import React from 'react';
import ChatRadioSelect from './ChatRadioSelect';

// Building picker wrapper so callers can keep the select-like onChange event shape.
const ChatBuildingSelect = ({
  value,
  onChange,
  options = [],
  ariaLabel,
  disabled = false,
  placeholder = '',
  variant = 'outlined'
}) => (
  <ChatRadioSelect
    value={value}
    options={options}
    ariaLabel={ariaLabel}
    disabled={disabled}
    placeholder={placeholder}
    variant={variant}
    onChange={(id) => {
      if (typeof onChange === 'function') {
        onChange({ target: { value: String(id) } });
      }
    }}
  />
);

export default ChatBuildingSelect;
